export function ErrorView({ message }: { message: string }) {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="max-w-sm text-center">
        <div className="mb-4 text-5xl">⚠️</div>
        <h1 className="mb-2 text-xl font-semibold">Что-то сломалось</h1>
        <p className="text-tg-hint">{message}</p>
      </div>
    </div>
  );
}
